// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"58a22d64","667":"de47ae6c","977":"d967af88"}[chunkId] + ".chunk.js";
};